import {Alert, Icon, icon} from '@hm/fundamental'
import React from 'react'
import {useTranslation} from 'react-i18next'

export const CrusherFlowInfoBanner: React.FC = () => {
  const {t} = useTranslation()

  return (
    <Alert variant="info">
      <div className="flex flex-row items-center gap-2">
        <Icon path={icon.mdiInformationOutline} size="large" className="text-primary" />
        <ul className="list-disc pl-6 m-0">
          <li>{t('plantSetup.crusherFlowSetup.info.allCrushersOnCanvas')}</li>
          <li>{t('plantSetup.crusherFlowSetup.info.moveAndConnect')}</li>
        </ul>
      </div>
    </Alert>
  )
}
